module.exports = __webpack_public_path__ + "static/media/radioButtonMark.379440c5.svg";